import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/panxo/Development/QC-AI/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/panxo/Development/QC-AI/web/node_modules/next/font/google/target.css?{\"path\":\"src/app/not-found.tsx\",\"import\":\"Barlow\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"barlow\"}");
;
import(/* webpackMode: "eager" */ "/Users/panxo/Development/QC-AI/web/src/styles/globals.css");
